import React from "react";
import { Page, SetupGuide } from "components";
import classNames from "lib/classNames";

const SetupScreen = ({ setIsOpen }) => {
  return (
    <>
      <Page background="white" header={{ title: "Getting Started" }}>
        <SetupGuide />
        <div
          className={classNames(
            "grid grid-flow-row gap-8 grid-cols-1 lg:grid-cols-3 mt-6"
          )}
        >
          <div
            className={classNames(
              "col-span-1 lg:col-span-2 text-gray-600 flex flex-col space-y-3"
            )}
          >
            <h3 className={classNames("font-bold text-lg leading-none")}>
              Setup guide - Increase revenue
            </h3>
            <iframe
              style={{
                width: "100%",
                height: 250,
                minWidth: 400,
                maxWidth: 450,
              }}
              frameBorder="0"
              allowFullScreen="1"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              title="Setup guide - Increase revenue"
              src="https://www.youtube.com/embed/22qamcR2eOc?autoplay=0&amp;cc_load_policy=1&amp;controls=2&amp;hl=en&amp;rel=0&amp;enablejsapi=1&amp"
            ></iframe>
          </div>
        </div>
        <p
          className={classNames(
            "w-full cursor-pointer hover:underline flex-1 text-gray-600 text-md font-bold mt-6"
          )}
          onClick={() => setIsOpen(true)}
        >
          Need help setting up campaigns or want best practices? Click here
        </p>
      </Page>
    </>
  );
};

export default SetupScreen;
